import React from "react";
import {Button, Grid, Spacer} from "@emburse/ui-core";
import {ArrowBackIcon, ArrowForwardIcon, Icon} from "@emburse/ui-essentials";
import {useNavigate} from "react-router";
import {BaseConfigurationContext} from "../../context/BaseConfigurationContext";
import {lodash} from "../../utils";

export interface BottomNavBarProps {
    prevDataQA?: string;
    prevText?: string;
    prevRoutes?: string;
    nextDataQA?: string;
    nextText?: string;
    nextRoutes?: string;
}

export const BottomNavBar = (props: BottomNavBarProps) => {
    const navigate = useNavigate();
    const {isInsideEmbark, basePath} = React.useContext(BaseConfigurationContext);
    const spacerHeight = `${isInsideEmbark ? 24 : 105}px`;

    return (
        <>
            <Grid container data-qa="navigation-page" alignItems='center' justifyContent='space-between'>
                <Grid item>
                    {!lodash.isNil(props.prevRoutes) &&
                        <Button id="back-navigation"
                                data-qa={props.prevDataQA}
                                variant="text"
                                style={{float: "left"}}
                                startIcon={<Icon iconUrl={ArrowBackIcon}/>}
                                 onClick={() => {
                                    navigate(basePath + '/' + props.prevRoutes!);
                                 }}>
                            {props.prevText}
                        </Button>
                    }
                </Grid>
                <Grid item>
                    {!lodash.isNil(props.nextRoutes) &&
                        <Button id="next-navigation"
                                data-qa={props.nextDataQA}
                                variant="text"
                                endIcon={<Icon iconUrl={ArrowForwardIcon}/>}
                                style={{float: "right"}}
                                 onClick={() => {
                                    navigate(basePath + '/' + props.nextRoutes!);
                                 }}>
                            {props.nextText}
                        </Button>
                    }
                </Grid>
            </Grid>
            <Spacer size={spacerHeight}/>
        </>
    )
}